
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.72 6.04c.47.457 1.21.483 1.71.06.37-.32.69-.51.87-.43.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31a3.587 3.587 0 001.34 2.98 3 3 0 002.64.46c1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79a6.111 6.111 0 00-5.38 5.37 3.158 3.158 0 003.21 3.09c1.63 0 4.29-1.33 4.69-6.1h1.21a1.25 1.25 0 000-2.5h-1.22c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92a18.248 18.248 0 011.85-3.52 5.3 5.3 0 001.3-3.28A2.635 2.635 0 006.44 3a4.223 4.223 0 00-2.7 1.22 1.257 1.257 0 00-.02 1.82zm10.16 12.51a.751.751 0 01-.74-.72 3.54 3.54 0 012.87-2.76c-.3 2.69-1.43 3.48-2.13 3.48z"}})])
          )
        }
      }
    